import { useStudentStore } from "../../hooks/use-student-store";

const QuizSection = () => {
  const { startQuiz, startClarify, submission, allMaterialsOpened } = useStudentStore();
  const materialsComplete = allMaterialsOpened();

  if (submission?.status === "COMPLETED") return null;

  return (
    <div className="pt-4 border-t border-gray-100">
      <button
        onClick={materialsComplete ? startClarify : undefined}
        disabled={!materialsComplete}
        className={`text-sm text-left mb-6 block ${!materialsComplete ? "opacity-50 cursor-not-allowed" : ""}`}
      >
        <span className="font-semibold text-blue-600">Clarify with AI</span>
        <span className="text-gray-600"> - Ask questions to improve understanding</span>
      </button>

      <button
        onClick={materialsComplete ? startQuiz : undefined}
        disabled={!materialsComplete}
        className={`block w-full text-center group ${!materialsComplete ? "opacity-50 cursor-not-allowed" : ""}`}
      >
        <div className="w-32 h-32 mx-auto mb-3 relative">
          <div className="absolute inset-0 bg-linear-to-br from-blue-100 via-purple-100 to-pink-100 rounded-xl" />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="relative">
              <div className="w-14 h-18 bg-amber-50 rounded border-2 border-amber-200 shadow-sm">
                <div className="absolute -top-2 left-1/2 -translate-x-1/2 w-7 h-3 bg-gray-300 rounded-t-sm border-2 border-gray-400" />
                <div className="pt-4 px-1.5 space-y-1">
                  <div className="flex items-center gap-1">
                    <span className="text-green-500 text-[10px] font-bold">✓</span>
                    <div className="h-1 bg-gray-200 flex-1 rounded" />
                  </div>
                  <div className="flex items-center gap-1">
                    <span className="text-green-500 text-[10px] font-bold">✓</span>
                    <div className="h-1 bg-gray-200 flex-1 rounded" />
                  </div>
                  <div className="flex items-center gap-1">
                    <span className="text-green-500 text-[10px] font-bold">✓</span>
                    <div className="h-1 bg-gray-200 flex-1 rounded" />
                  </div>
                </div>
              </div>
              <div className="absolute -right-3 -bottom-1 w-10 h-2.5 bg-amber-400 rounded-full transform rotate-45 shadow">
                <div className="absolute right-0 w-1.5 h-1.5 bg-amber-200 rounded-full -translate-y-0.5" />
              </div>
            </div>
          </div>
        </div>
        <h3 className="text-base font-semibold text-gray-900 group-hover:text-blue-600">
          Take the Quiz
        </h3>
        <p className="text-sm text-gray-500">Check your understanding</p>
      </button>

      {!materialsComplete && (
        <p className="text-xs text-amber-600 mt-2 text-center">
          Please open all learning materials before proceeding
        </p>
      )}
    </div>
  );
};

export default QuizSection;
